import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, catchError, of } from 'rxjs';

import { routeNames } from '../../../shared/route-names';
import { UserService } from '../../user/services/user.service';
import { ReturnUrlService } from '../../auth/services/return-url.service';

export const LoggedInGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const userService = inject(UserService);
  const returnUrlService = inject(ReturnUrlService);

  // Get the requested URL from the router state
  // This gives us the original URL the user tried to access
  const requestedUrl = state.url;

  // If we have a token, allow access and try to fetch user data if needed
  if (userService.hasToken()) {
    // If we already have user data, we're good
    const currentUser = userService.getUser().value;
    if (currentUser) {
      return true;
    }

    // We have a token but no user data - fetch it
    return userService.fetchUser().pipe(
      map(() => true),
      catchError(() => {
        // If fetchUser fails, the token is probably invalid
        // Store return URL and navigate to login
        returnUrlService.setReturnUrl(requestedUrl);
        return of(router.parseUrl(routeNames.login));
      })
    );
  }

  // No token at all - store return URL and redirect to login
  returnUrlService.setReturnUrl(requestedUrl);
  return router.parseUrl(routeNames.login);
};
